import { Fragment } from "react";
import { useRouter } from "next/router";

import { Transition } from "@headlessui/react";

export default function Onboarding() {
  const router = useRouter();
  const { client } = router.query;
  return (
    <Transition
      appear={true}
      show={true}
      as={Fragment}
      enter="ease-out duration-300"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="ease-in duration-200"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className="fixed z-10 inset-0 overflow-hidden">
        <div className="flex flex-col min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <div className="fixed inset-0 bg-coolGray-900 transition-opacity"></div>
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen">
            &#8203;
          </span>
          {/* Start Modal */}
          <div className="inline-block bg-coolGray-900 rounded-lg text-left transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full sm:px-6 sm:pt-2 sm:pb-8">
            <div className="grid grid-cols-1 gap-2 my-10">
              <div>
                <div className="mt-3 text-center">
                  <h3
                    className="text-lg 2xl:text-4xl leading-6 font-bold text-blueGray-200"
                    id="modal-title"
                  >
                    Unknown Client
                  </h3>
                  <div className="mt-2 xl:mt-8">
                    <p className="text-lg text-blueGray-300 mb-2 text-center">
                      Please check the URL to verify you have the correct client
                      id.
                    </p>
                    <p className="text-lg text-blueGray-300 mb-2 text-center">
                      You entered {client}, which is not a registered public
                      entity.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End Modal */}
        </div>
      </div>
    </Transition>
  );
}
